import { isNullOrUndefined, isWithinRecallEligibilityPeriod } from '../../utils/formatting'
import Address from '../Customer/Address'
import CustomerName from '../Customer/CustomerName'
import { EligibilityOutcome, PremisesDetails } from '../Property'
import DigitalAddress from '../shared/Address/DigitalAddress'
import { RaisedBy } from '../shared/RaisedBy'
import { Statuses } from '../shared/Statuses'
import { WorksOrder as BaseWorksOrder } from '../WorksOrders'
import { Priority } from '../WorksOrders/Job/Priority'
import { MetaData } from '../WorksOrders/MetaData'
import { CreatedRepair, RepairContact, RepairDetails } from './CreateRepair'

export type SupplementaryQuestionResponse = {
  questionId: string;
  questionLabel: string;
  responseId: string[];
  responseValue: string;
};
export interface WorksOrder extends BaseWorksOrder {
}
class CurrentStep {
  public value: number = 0
  public key: string = ''
  public displayName: string = ''
  public legacyKeys: any[] = []
}
export class Documents {
  public documentIdentifiers: string[] = [];
}

export class HhsrsAssessment {
  public category: string | null = null;
  public severity: string | null = null;
}

export class assessmentInformation {
  public supplementaryQuestionResponses: SupplementaryQuestionResponse[] | undefined = undefined;
  public outcome: Outcome | undefined = undefined;
  public type: string | undefined = undefined;
  public identifier : string | undefined= undefined;
  public communicationPreference: CommunicationPreference | undefined = undefined;
  public hasAdditionalNeeds: boolean | undefined = undefined;
  public isSupportedResident: boolean | undefined = undefined;
}

export class CommunicationPreference {
  public preferenceType: string = '';
  public addresses: addresses | undefined = undefined;
}

export class addresses {
  public digitalAddresses: digitalAddresses[] | undefined = undefined;
}
export class postalAddresses {
  public addressLine1: string = '';
  public addressLine2: string = '';
  public addressLine3: string = '';
  public postcode: string = '';
  public postalAddressType: string = '';
  public isPreferred: boolean = false;
}

export class digitalAddresses {
  public address: string = '';
  public digitalAddressType: string = '';
}

export class Outcome {
  public adjustedRiskRating: string = '';
  public riskRating: string = '';
  public totalScore: number = 0;
  public vulnerabilityScore: number = 0;
  public vulnerabilityRiskRating: string = '';
  public contractorPropertyRating: string = '';
  public communicationPreference: string = '';
}

export class CompletedStep {
  public value: number = 0
  public key: string = ''
  public displayName: string = ''
  public legacyKeys: any[] = []
  constructor(step?: number) {
    this.value = step || 0
  }
}

export enum NoteType {
  CCIM = "1",
  Chase = "2",
  Other = "3",
}

export enum RepairStatusText {
  Unappointed = 'Unappointed',
  Appointed = 'Appointed',
  InProgress = 'In progress',
  InDiagnosis = 'In Diagnosis',
  Completed = 'Completed',
  Closed = 'Closed',
  Cancelled = 'Cancelled',
  ReportedToEMA = 'Reported to EMA',
  PendingAssessment = 'Pending Assessment'
}


export class ReportContactDetails {
  public name: CustomerName | null | undefined = null
  public contactNumber: string | null = null
  public organisation: string | null = null
  public reporterToBeContacted: boolean = false
}


export class CurrentRepair {
  public static canBeScheduled = (
    repair: Pick<CurrentRepair, 'status' | 'priority' | 'isRecall'>
  ): boolean => {
    const { status, priority } = repair

    return (
      status === RepairStatusText.Unappointed &&
      priority === 'Next Available'
    )
  }
  public static canBeRecalled = (
    repair: Pick<CurrentRepair, 'status' | 'priority' | 'completedDate' | 'sorCode' | 'isRecall'>
  ): boolean => {
    

    // default true for non gas scenarios
    let displayRecallFeatureToggleCheck: boolean = true
    return (
      (repair.status === RepairStatusText.Completed || repair.status === RepairStatusText.Closed) &&
      repair.priority === 'Next Available' &&
      isWithinRecallEligibilityPeriod(repair.completedDate) &&
      !repair.isRecall &&
      displayRecallFeatureToggleCheck
    )
  }

  public id: string
  public originalWorkOrderIdentifier?: string | undefined
  public originalWorkOrderJobId?: string | undefined
  public originalWorkOrderSorCode?: string | undefined
  public isDraft: boolean
  public isSupplementary?: boolean | null
  public isVandalism?: boolean | null
  public isSubmitted?: boolean | null
  public isCovidSelfIsolated?: boolean | null
  public premisesId: string
  public area: string = ''
  public areaAddress: string = ''
  public premisesType: string = ''
  public premisesTypeId: string = ''
  public premisesAddress: Address | null = null
  public contractor: string = ''
  public contractorName?: string
  public contractorPhoneNumber?: string = ''
  public contractorBuilderName?: string = ''
  public contractorBuilderPhone?: string = ''
  public trade: string = ''
  public repairLocation: string = ''
  public repairLocationId: string = ''
  public isEmergency: boolean = false
  public isOutOfHours: boolean = false
  public priority: string = ''
  public priorityCode: string = ''
  public status: string = ''
  public raisedDate: string = ''
  public appointmentStartDate: any
  public appointmentEndDate: any
  public appointmentDates: object = {}
  public completedDate: any
  public description: string = ''
  public repairReason: string = ''
  public surveyReason: string = ''
  public repairType: string = ''
  public additionalInformation: string = ''
  public documents: Documents = new Documents();
  public hhsrsAssessment: HhsrsAssessment = new HhsrsAssessment();
  public workProgramme: string = ''
  public jobNo: string = ''
  public repairAddress: string = ''
  public chargeCustomer: any
  public repairCause?: string = ''
  public repairCauseId?: number = 0
  public riskToHumanLife?: boolean = undefined
  public crimeReferenceNumber: string | null = null
  public reportedById?: number
  public reportedBy: string = ''
  public notifyAll: boolean
  public staffContactEmails: string[] = []
  public currentStep: CurrentStep = new CurrentStep()
  public completedStep: CompletedStep = new CompletedStep()
  public reportingMethodId: number = 1
  public reportingMethod?: string = ''
  public eTag: string = 'eTag'
  public reporterToBeContacted: boolean = true
  public reporterContactDetails: ReportContactDetails | null = new ReportContactDetails()
  public customerName: CustomerName | null = new CustomerName()
  public premisesUniqueReference: string = ''
  public sorCode: string = ''
  public hazardSorCode?: string
  public raisedBy: RaisedBy = new RaisedBy()
  public staffContactDigitalAddresses: DigitalAddress[] = []
  public worksOrderIdentifier: string = ''
  public customerIdentifier: string = ''
  public isRecall?: boolean
  public isCausingDampAndMould: boolean | null = null
  public isSendCopyOfDampMouldReport: boolean = false
  public eligibilityOutcomes: EligibilityOutcome[] = []
  public isCatalyst: boolean = false
  public caseIdentifier: string = ''
  public isEMA: boolean = false
  public isInDefect: boolean = false
  public elementCode: string = "";
  public smv: number = 0;
  public alternateUserEmailAddress: string = ''
  public isEnhancedDiagnosticsRepair?: boolean = false
  public repairDiagnosticsSessionIdentifier?: string = ''
  public assessmentIdentifier?: string = ''
  public statusMetaData?: MetaData[] = []
  public isPendingAssessment: boolean = false
  public isPotentialDuplicate: boolean = false

  public isVulnerable?: boolean | null
  public VulnerableResponseText: any
  public assetIdentifier: string
  public channel: string = ''
  public assessmentInformation: assessmentInformation | undefined;
  public associatedWorkOrdersIdentifier: string = ''
  public associatedWorkOrdersType: string = ''
  public associatedWorkOrdersJobNumber: string = ''

  public isHHSRSHazard: boolean | null




  constructor(worksOrder?: WorksOrder, premisesInfo?: PremisesDetails) {
    this.id = worksOrder?.identifiers?.worksOrderIdentifier || ''
    this.originalWorkOrderIdentifier =
      worksOrder?.identifiers?.originalWorkOrderIdentifier || undefined
    this.originalWorkOrderSorCode = worksOrder?.job?.sorCode || undefined
    this.isDraft = !isNullOrUndefined(worksOrder?.statuses?.isDraft) ? Boolean(worksOrder?.statuses?.isDraft) : true
    this.isSupplementary = worksOrder?.statuses?.isSupplementary || null
    this.isCausingDampAndMould = worksOrder?.statuses?.isCausingDampAndMould ?? null
    this.isSendCopyOfDampMouldReport = worksOrder?.statuses?.isSendCopyOfDampMouldReport || false
    this.isHHSRSHazard = worksOrder?.statuses?.isHHSRSHazard ?? null
    // Add hhsrsAssessment from worksOrder if present
    if (worksOrder?.hhsrsAssessment) {
      const category = worksOrder.hhsrsAssessment.category ?? null;
      const severity = worksOrder.hhsrsAssessment.severity ?? null;
      if (category && severity) {
        this.hhsrsAssessment = {
          category,
          severity
        };
      }
    }
    if (worksOrder?.statuses?.isVandalism === false) {
      this.isVandalism = false;
    }
    else {
      this.isVandalism = worksOrder?.statuses?.isVandalism || null
    }
    if (worksOrder?.statuses?.isCovidSelfIsolated === false) {
      this.isCovidSelfIsolated = false;
    }
    else {
      this.isCovidSelfIsolated = worksOrder?.statuses?.isCovidSelfIsolated || null
    }
    this.premisesId = worksOrder?.identifiers?.asset?.assetIdentifier || ''
    this.premisesAddress = premisesInfo?.premises?.address || null
    this.premisesTypeId = worksOrder?.asset?.type?.assetTypeId || ''
    this.premisesType = premisesInfo?.premises?.premisesType || ''
    this.area = worksOrder?.asset?.type?.assetTypeName || ''
    this.areaAddress = worksOrder?.asset?.fullAddress || ''
    this.contractor = worksOrder?.identifiers?.contractorSiteIdentifier || ''
    this.caseIdentifier = worksOrder?.identifiers?.caseIdentifier || ''
    this.contractorName = worksOrder?.contractor?.name || ''
    this.trade = worksOrder?.job?.trade || ''
    this.repairLocation = worksOrder?.job?.location?.location || ''
    this.repairLocationId = worksOrder?.job?.location?.locationId || ''
    this.repairReason = worksOrder?.job?.repairReason || ''
    this.surveyReason = worksOrder?.job?.surveyReason || ''
    this.repairType = worksOrder?.job?.repairType || ''
    this.isEmergency = worksOrder?.statuses?.isEmergency || false
    this.isOutOfHours = worksOrder?.statuses?.isOutOfHours || false
    const calculatedPriority = this.retrievePriority(worksOrder?.job?.priority, worksOrder?.statuses)
    this.priority = calculatedPriority || ''
    this.priorityCode = worksOrder?.job?.priority?.code || ''
    this.status = worksOrder?.statuses?.status || ''
    this.raisedDate = worksOrder?.raisedDate || ''
    this.isEMA = worksOrder?.statuses?.isEMA || false
    this.isEnhancedDiagnosticsRepair = worksOrder?.statuses?.isEnhancedDiagnosticsRepair || false
    this.repairDiagnosticsSessionIdentifier = worksOrder?.identifiers?.repairDiagnosticsSessionIdentifier || ''
    this.assessmentIdentifier = worksOrder?.assessmentInformation?.identifier || worksOrder?.identifiers?.assessmentIdentifier || ''
    this.statusMetaData = worksOrder?.statuses?.metaData || []
    this.isCatalyst = worksOrder?.statuses?.isCatalyst || false
    this.isInDefect = worksOrder?.asset?.isInDefect || false
    this.isInDefect = worksOrder?.asset?.isInDefect || false
    this.isPendingAssessment = worksOrder?.statuses?.isPendingAssessment || false
    this.isPotentialDuplicate = worksOrder?.statuses?.isPotentialDuplicate || false
    this.isCausingDampAndMould = worksOrder?.statuses?.isCausingDampAndMould ?? null
    this.elementCode = worksOrder?.job?.elementCode ?? "";
    this.smv = worksOrder?.job?.smv ?? 0;
    this.isSendCopyOfDampMouldReport = worksOrder?.statuses?.isSendCopyOfDampMouldReport || false
    if (worksOrder?.customer?.vulnerability?.isVulnerable === false) {
      this.isVulnerable = false;
    }
    else {
      this.isVulnerable = worksOrder?.customer?.vulnerability?.isVulnerable || null
    }
    this.VulnerableResponseText = worksOrder?.customer?.vulnerability?.vulnerableResponseText || null

    const appointmentStartDate =
      worksOrder?.appointments && worksOrder?.appointments.length > 0
        ? worksOrder.appointments?.[0]?.appointmentStartDate
        : undefined
    this.appointmentStartDate = appointmentStartDate

    const appointmentEndDate =
      worksOrder?.appointments && worksOrder?.appointments.length > 0
        ? worksOrder.appointments?.[0]?.appointmentEndDate
        : undefined
    this.appointmentEndDate = appointmentEndDate

    this.appointmentDates = this.appointmentDates = {
      appointmentStartDate,
      appointmentEndDate,
    }

    this.completedDate = worksOrder?.completedDate
    this.description = worksOrder?.job?.description || ''
    this.repairReason = worksOrder?.job?.repairReason || ''
    this.surveyReason = worksOrder?.job?.surveyReason || ''
    this.repairType = worksOrder?.job?.repairType || ''

    this.additionalInformation = worksOrder?.job?.additionalInformation || ''
    this.workProgramme = worksOrder?.job?.workProgramme || ''
    this.jobNo = worksOrder?.identifiers?.jobNumber || ''
    this.chargeCustomer = worksOrder?.customer?.person?.chargeCustomer || false
    this.repairCause = worksOrder?.job?.cause ? worksOrder.job.cause.cause : ''
    this.repairCauseId = worksOrder?.job?.cause ? worksOrder?.job.cause.causeId : undefined
    this.riskToHumanLife = worksOrder?.statuses?.isRiskToHumanLife || undefined
    this.crimeReferenceNumber = worksOrder?.identifiers?.crimeReferenceNumber || ''
    this.reportedById = worksOrder?.reporter?.reporterRelationship?.reportedById || undefined
    this.reportedBy = worksOrder?.reporter?.reporterRelationship?.reportedBy || ''
    this.notifyAll = worksOrder?.customer?.notification?.notifyAll || false
    this.staffContactEmails = this.getStaffContactEmailsFromDigitalAddress(
      worksOrder?.customer?.notification?.address?.digitalAddresses || []
    )
    this.currentStep = worksOrder ? this.calculateCurrentStep(worksOrder) : new CurrentStep()
    this.completedStep = worksOrder ? this.calculateCompletedStep(worksOrder) : new CompletedStep()
    this.reportingMethodId = worksOrder?.reporter?.reportingMethod?.reportingMethodId || 1
    this.reportingMethod = worksOrder?.reporter?.reportingMethod?.reportingMethod || ''
    this.eTag = worksOrder?.eTag || ''
    this.channel = worksOrder?.channel || ''
    this.reporterToBeContacted =
      worksOrder?.reporter?.reporterToBeContacted === true ? true : false
    this.reporterContactDetails = worksOrder?.reporter?.reporterToBeContacted
      ? {
        name: new CustomerName({
          title: null,
          givenName: `${worksOrder?.reporter?.person?.name?.givenName || ''} ${worksOrder?.reporter?.person?.name?.surname}`,
          surname: null,
        }),
        contactNumber: worksOrder?.reporter?.addresses?.telecomsAddresses?.[0]?.number ?? '',
        organisation: worksOrder?.reporter?.organisation || '',
        reporterToBeContacted: worksOrder?.reporter?.reporterToBeContacted,
      }
      : null

    this.customerName = new CustomerName({
      title: worksOrder?.customer?.person?.name?.title || '',
      givenName: worksOrder?.customer?.person?.name?.givenName || '',
      surname: worksOrder?.customer?.person?.name?.surname || '',
    })
    this.premisesUniqueReference = worksOrder?.identifiers?.asset?.premisesUniqueReference ?? ''
    this.sorCode = worksOrder?.job?.sorCode || ''
    this.hazardSorCode = worksOrder?.job?.hazardSorCode
    this.raisedBy = worksOrder?.raisedBy || new RaisedBy()
    this.staffContactDigitalAddresses =
      worksOrder?.customer?.notification?.address?.digitalAddresses || []
    this.worksOrderIdentifier = worksOrder?.identifiers?.worksOrderIdentifier || ''
    this.customerIdentifier = worksOrder?.identifiers?.customerIdentifier || ''
    this.isRecall = worksOrder?.statuses?.isRecall || undefined
    this.eligibilityOutcomes = worksOrder?.eligibilityOutcomes ?? []
    this.assetIdentifier = worksOrder?.identifiers?.asset?.assetIdentifier ?? ''
    this.documents = worksOrder?.identifiers?.documents ? worksOrder?.identifiers?.documents : new Documents()
    this.hhsrsAssessment = worksOrder?.hhsrsAssessment ?? new HhsrsAssessment()
    this.assessmentInformation = worksOrder?.assessmentInformation
      ? {
        supplementaryQuestionResponses: worksOrder.assessmentInformation?.supplementaryQuestionResponses ? worksOrder.assessmentInformation?.supplementaryQuestionResponses?.map(response => ({
          questionId: response.questionId,
          questionLabel: response.questionLabel,
          responseId: response.responseId,
          responseValue: response.responseValue,
        })) : undefined,
        outcome: worksOrder.assessmentInformation?.outcome,
        communicationPreference: worksOrder.assessmentInformation?.communicationPreference,
        type: worksOrder.assessmentInformation?.type,
        identifier: worksOrder.assessmentInformation?.identifier,
        hasAdditionalNeeds: worksOrder.assessmentInformation?.hasAdditionalNeeds,
        isSupportedResident: worksOrder.assessmentInformation?.isSupportedResident
      }
      : undefined;
    this.associatedWorkOrdersIdentifier = worksOrder?.identifiers?.associatedWorkOrders?.[0]?.identifier || ''
    this.associatedWorkOrdersType = worksOrder?.identifiers?.associatedWorkOrders?.[0]?.type || ''
    this.associatedWorkOrdersJobNumber = worksOrder?.identifiers?.associatedWorkOrders?.[0]?.jobNumber || ''
  }

  public getStaffContactEmailsFromDigitalAddress = (digitalAddressEmails: DigitalAddress[]) => {
    const staffContactEmails: string[] = digitalAddressEmails.map(address => {
      return address?.address ?? ''
    })
    return staffContactEmails
  }

  public retrievePriority = (priority?: Priority | null, statuses?: Statuses | null) => {

    if (priority != null) {
      return priority?.priority
    }
    else if (statuses) {
      const { isEmergency, isOutOfHours } = statuses
      if (!isEmergency) {
        return 'Next Available'
      }
      if (isEmergency && !isOutOfHours) {
        return 'Emergency'
      }
      if (isEmergency && isOutOfHours) {
        return 'Emergency (Out of hours)'
      }
    }
    return ''
  }

  public calculateCompletedAndCurrentStep = (
    worksOrder: WorksOrder
  ): { currentStep: CurrentStep; completedStep: CompletedStep } => {
    if (
      worksOrder.statuses?.status !== 'Unappointed' &&
      worksOrder.statuses?.status !== 'In Diagnosis'
    ) {
      return {
        completedStep: { value: 5, key: '', displayName: '', legacyKeys: [] },
        currentStep: { value: 5, key: '', displayName: '', legacyKeys: [] },
      }
    }
    if (worksOrder.identifiers?.jobNumber) {
      return {
        completedStep: { value: 4, key: '', displayName: '', legacyKeys: [] },
        currentStep: { value: 5, key: '', displayName: '', legacyKeys: [] },
      }
    }
    if (worksOrder?.reporter && worksOrder.reporter.reportingMethod.reportingMethodId !== null) {
      return {
        completedStep: { value: 3, key: '', displayName: '', legacyKeys: [] },
        currentStep: { value: 4, key: '', displayName: '', legacyKeys: [] },
      }
    }
    if (
      worksOrder.customer?.person?.chargeCustomer !== null &&
      worksOrder.customer?.person?.chargeCustomer !== undefined
    ) {
      return {
        completedStep: { value: 2, key: '', displayName: '', legacyKeys: [] },
        currentStep: { value: 3, key: '', displayName: '', legacyKeys: [] },
      }
    }
    return {
      completedStep: { value: 1, key: '', displayName: '', legacyKeys: [] },
      currentStep: { value: 2, key: '', displayName: '', legacyKeys: [] },
    }
  }

  public calculateCurrentStep = (worksOrder: WorksOrder) => {
    const steps = this.calculateCompletedAndCurrentStep(worksOrder)
    return steps.currentStep
  }

  public calculateCompletedStep = (worksOrder: WorksOrder) => {
    const steps = this.calculateCompletedAndCurrentStep(worksOrder)
    return steps.completedStep
  }
}

export type OriginalRepair = {
  identifier?: string
  jobId?: string
  sorCode?: string
}

export type RepairEndPoint<T extends CreatedRepair | RepairDetails | RepairContact> = {
  id: string
  premisesId: string
} & T

export type RepairNote = {
  type: string
  text: string
  author: string
  creationDate: string
}

export type ExtendedRepairNote = {
  type: string
  text: string
  author: string
  creationDate: string
  createdBy: string,
  title: string
}

export type RepairNotePayload = {
  text: string
  noteTypeId: number
}

export type RepairHistory = {
  type?: string
  identifier?: string
  statusTitle?: string
  comments?: string
  createdBy?: string
  createDateTime?: string
}

export enum RepairReporterId {
  Customer = 1,
  "Friend or Family" = 2,
  MemberOfStaff = 3,
  SupportWorker = 4,
  Other = 5,
}

export enum RepairStatusField {
  Unknown = "Unknown",
  InDiagnosis = 'In Diagnosis',
  Unappointed = 'Unappointed',
  Appointed = 'Appointed',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  OnHold = "On Hold",
  PendingApproval = 'Pending Approval',
  ReportedToEMA = 'Reported to EMA',
  Assignedcontractor = 'Assigned to contractor',
  UnderReview = 'Under review',
  CatalystTier2Triage = 'Catalyst Tier 2 Triage',
  CatalystEMATriage = 'Managing Agent',
  CatalystDefectTriage = 'Catalyst Defect Triage',
  RepairStatusFieldCatalyst = 'Passed to Peabody',
  CatalystEMAStatus = 'Assigned to Managing Agent',
  Tier2 = 'Tier 2',
  Assignedtosurveyor = 'Unappointed',
  EMAtriage = 'EMA triage',
  Defecttriage = 'Defect triage',
  CatalystManagingAgentStatus = "Catalyst Managing Agent Triage",
  isPendingAssessment = 'Pending Assessment'
}

export enum HistoryIdentifier {
  APCREATE01 = "APCREATE01",
  APCREATE02 = "APCREATE02",
  APCREATE03 = "APCREATE03",
  APCREATE04 = "APCREATE04",
  APCREATE05 = "APCREATE05",
  APCREATE06 = "APCREATE06",
  APCREATE07 = "APCREATE07",
  APCREATE08 = "APCREATE08",
  APCREATE09 = "APCREATE09",
  APCREATE10 = "APCREATE10"
}
